/* eslint-disable quote-props */
/*
===============================================================================
FUNZIONE DI ISCRIZIONE ALLA NEWSLETTER AUTOMATICA v.0.1.2 - 12/05/2016
-------------------------------------------------------------------------------
Funzione principale per inserire gli utenti che si iscrivono alla newsletter da
una qualunque popup e/o area promozionale con inserimento automatico dentro il
database di Mailup senza perdita del submit della form originale, con l'opzione
dell'invio del coupon sconto.
-------------------------------------------------------------------------------
TODO Ottimizzare il CSS del pulsante, magari con una classe ad hoc
===============================================================================
*/
// eslint-disable-next-line no-unused-vars
function submitNewsletter($form, $pulsante, nlemail, nlnome, nlcognome, sendCoupon) {

  // Controllo che tutti i parametri obbligatori siono stati passati
  // try {
  //   if ($form === undefined || $form === null) throw 'form';
  //   if ($pulsante === undefined || $pulsante === null) throw 'pulsante';
  //   if (nlemail === undefined || nlemail === null) throw 'email';
  //   if (nlnome === undefined || nlnome === null) throw 'nome';
  //   if (nlcognome === undefined || nlcognome === null) throw 'cognome';
  // }
  // catch(err) {
  //   console.log('Errore - Argomento ' + err + ' non passato');
  //   return;
  // }

  // Mostro l'icona di caricamento
  $pulsante.html('<span class="fa fa-spinner fa-spin fa-lg"></span>');

  // Definisco e assegno le variabili necessarie alla richiesta Mailup
  const lista = 1;
  const gruppo = 29; // Iscritti alla newsletter gioielloro
  const ritCodice = 1; // Attiva la risposta alla request sotto forma numerica
  const conferma = false; // Disattiva la conferma di iscrizione
  const csvFldNames = 'campo1;campo2;';
  const csvFldValues = '' + nlnome + ';' + nlcognome + ';';

  // Passo l'email, il nome e il cognome alla pagina proxy che eseguirà una
  // GET alla console di mailup per inserirlo nella lista e nel gruppo
  // degli iscritti alla newsletter
  $.ajax({
    url: '../proxy_newsletter.php',
    type: 'POST',
    data: {
      list: lista,
      group: gruppo,
      retCode: ritCodice,
      confirm: conferma,
      email: nlemail,
      csvFldNames: csvFldNames,
      csvFldValues: csvFldValues
    },
    success: function (data) {
      console.log(data);

      // Controllo se l'iscrizione è andata a buon fine (risposta 0)
      if (parseInt(data, 10) === 0) {

        // Controllo se la form prevede l'invio di un coupon tramite parametro
        if (sendCoupon === true) {

          // Eseguo la chiamata al file con l'email del coupon
          $.ajax({
            url: '../it/email/email_coupon.php',
            method: 'POST',
            data: { email: nlemail, nome: nlnome, cognome: nlcognome },
            success: function (data2) {
              console.log(data2);

              // Eseguo il submit originale della form
              $form.submit();

            }
          });
        } else {
          // Eseguo il submit originale della form
          $form.submit();
        }

        // Se l'utente risulta già iscritto (risposta 3)
      } else if (parseInt(data, 10) === 3) {

        $pulsante.css({
          'background-color': '#5cb85c',
          'border-color': '#5cb85c',
          'position': 'absolute',
          'top': '0',
          'left': '0',
          'margin': '0',
          'height': '100%',
          'padding': '30px',
          'font-size': '1.8rem',
          'white-space': 'normal'
        });

        // Attendo che l'utente veda il messaggio e faccio comunque il submit
        // per poter mostrare i prezzi scontati
        $pulsante.html('RISULTI GIA\' ISCRITTO <br /> TRA POCO VEDRAI I PREZZI SCONTATI');
        setTimeout(function () { $form.submit(); }, 2000);

        // Se l'iscrizione ha dato esito negativo
        // 1 --> Generic Error
        // 2 --> Invalid email address or mobile number
      } else {
        $pulsante.css({
          'background-color': '#e74c3c',
          'border-color': '#e74c3c'
        });

        // Restituisco all'utente sul pulsante l'errore relativo
        switch (parseInt(data, 10)) {
          case 1:
            $pulsante.html('SI E\' VERIFICATO UN ERRORE, RIPROVA');
            break;
          case 2:
            $pulsante.html('INDIRIZZO EMAIL NON VALIDO, RIPROVA');
            break;
          default:
            $pulsante.html('SI E\' VERIFICATO UN ERRORE, RIPROVA');
        }
      }
    }
  });
}
